// fr_pms_checkin_stay.ts
// Tłumaczenia dla PMS.Checkin.tsx i PMS.Stay.tsx (oba ekrany Front Desk)

export const frPmsCheckinStay = {

  // ── Zameldowanie (Checkin) ────────────────────────────────────────────────
  checkin: {
    title:               "Reception",
    arrivalsToday:       "Arrivees aujourd'hui",
    preCheckIn:          "Pre-arrivee",
    earlyCheckIn:        "Arrivee anticipee",
    depositRule:         "Regle de depot",
    depositRuleRequired: "La regle de depot est requise.",
    documentType:        "Type de document",
    passport:            "Passeport",
    idCard:              "Carte d'identite",
    preauth:             "Preautorisation",
    searchPlaceholder:   "Nom, numero de reservation, chambre, telephone, e-mail",
    readyRoom:           "Chambre prete",
    noReadyRoom:         "Aucune chambre prete",
    noRoom:              "Aucune chambre",
    missing:             "Manquant",
    garage:              "Garage",
    messages: {
      completed:          "Arrivee terminee. Le codage de cle est pret.",
      completedSimple:    "Arrivee terminee.",
      failed:             "Zameldowanie nieudane.",
      documentRegistered: "Document client enregistre et verifie.",
      documentFailed:     "Echec de l'enregistrement du document.",
    },
  },

  // ── Zarządzanie pobytem (Stay) ────────────────────────────────────────────
  stay: {
    title:       "Gestion du sejour",
    description: "Arrivees, sejours, changements de chambre, depart tardif et depart dans une seule vue.",
    inHouseStays:"Sejours en cours",
    frontOffice: "Front Office",
    frontOfficeActions:"Actions Front Office",
    checkoutSettlement:"Reglement du depart",
    selectStay:  "Selectionnez un sejour une fois, puis continuez avec le depart tardif, le changement de chambre ou le depart.",
    keepVisible: "Gardez les arrivees et l'activite visibles sans changer de page.",
    lateCheckout: {
      title:         "Depart tardif",
      description:   "Prolongez les sejours actifs et imputez le frais au folio.",
      applied:       "Depart tardif applique",
      workflowActive:"Le flux de depart tardif est actif. Le sejour actif est deja preselectionne.",
    },
    roomMove: {
      title:         "Changement de chambre",
      description:   "Deplacer le client vers une autre chambre prete et emettre une nouvelle cle.",
      completed:     "Changement de chambre termine et nouvelle cle emise.",
      failed:        "Przeniesienie pokoju nieudane.",
      selectRoom:    "Selectionnez une chambre prete avant de deplacer le client.",
    },
    checkout: {
      title:         "Depart",
      settle:        "Regler le folio, imprimer ou envoyer la facture par e-mail, puis terminer le depart.",
      failed:        "Wymeldowanie nieudane.",
      settled:       "Depart regle et facture generee.",
      workflowActive:"Le flux de depart est actif. Verifiez le folio et fermez le sejour.",
    },
  },

} as const;

export default frPmsCheckinStay;
